"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PremiumIconWrapper = exports.PremiumTextWrapper = exports.EditCompanyButton = exports.CompanyNumberBoxDiv = exports.PrimaryColorWrapper = exports.ImageBlock = exports.Header = exports.ProfileBoxBody = exports.ImageBlockWrapper = exports.AddIcon = exports.CompanyName = exports.CompanyNumbersTitle = exports.CompanyNumbers = void 0;
const styled_components_1 = __importStar(require("styled-components"));
const streamline_icon_add_svg_1 = __importDefault(require("@public/media/icons/streamline-icon-add.svg"));
const elements_1 = require("@src/components/elements");
const polished_1 = require("polished");
const mediaFromLaptop = '@media screen and (max-width: 1024px)';
exports.CompanyNumbers = styled_components_1.default.div `
	display: flex;
	align-items: center;
	justify-content: space-around;
	width: 100%;
`;
exports.CompanyNumbersTitle = styled_components_1.default.div `
	color: ${({ theme }) => theme.color.gray6};
	font-size: 1rem;
`;
exports.CompanyName = styled_components_1.default.h2 `
	margin: 0;
	margin-bottom: 2rem;
	font-size: 1.75rem;
	color: ${({ theme }) => theme.color.brand1};
	display: flex;
	align-items: center;
	justify-content: center;
	text-align: center;
	& > a:hover {
		text-decoration: underline;
	}
`;
exports.AddIcon = (0, styled_components_1.default)(streamline_icon_add_svg_1.default) `
	path {
		width: 100%;
		height: 100%;
	}
`;
exports.ImageBlockWrapper = styled_components_1.default.div `
	display: flex;
	position: relative;

	${mediaFromLaptop} {
		flex-direction: column;
	}
`;
exports.ProfileBoxBody = styled_components_1.default.div `
	padding: 1rem;
	position: relative;
	padding-top: 75px;
`;
exports.Header = styled_components_1.default.div `
	width: 100%;
	height: 90px;
	background: black url(${props => props.background}) no-repeat 50%;
	background-size: cover;
	border-radius: 4px 4px 0 0;

	${({ isInAdmin }) => isInAdmin &&
    (0, styled_components_1.css) `
			&:hover {
				cursor: pointer;
			}
		`}
`;
exports.ImageBlock = styled_components_1.default.div `
	position: absolute;
	border: 1px solid ${({ theme }) => theme.color.gray4};
	background: white;
	z-index: 1;
	top: -50px;
	left: calc(50% - 50px);
	width: 100px;
	height: 100px;
	overflow: hidden;
	display: flex;
	align-items: center;
	justify-content: center;
	border-radius: 4px;

	${({ isInAdmin }) => isInAdmin &&
    (0, styled_components_1.css) `
			&:hover {
				cursor: pointer;
			}
		`}

	& > * {
		padding: 4px;
		background: white;
		max-width: 100%;
		max-height: 100%;
	}

	svg {
		width: 70%;
		height: 70%;
		color: ${({ theme }) => theme.color.gray4};
	}
`;
exports.PrimaryColorWrapper = styled_components_1.default.span `
	color: ${({ theme }) => theme.color.brand1};
`;
exports.CompanyNumberBoxDiv = styled_components_1.default.div `
	flex: 1;
	display: flex;
	flex-direction: column;
	min-width: 0;
	align-items: center;
	margin-top: auto;
`;
exports.EditCompanyButton = (0, styled_components_1.default)(elements_1.Button) `
	width: 100%;
	justify-content: center;
	margin-bottom: 0.25rem;
`;
exports.PremiumTextWrapper = styled_components_1.default.div `
	color: ${({ theme }) => theme.color.gray6};
`;
exports.PremiumIconWrapper = styled_components_1.default.div `
	margin-right: 0.5rem;
	background: ${({ theme }) => (0, polished_1.transparentize)(0.8, theme.color.brand1)};
	width: 1.5rem;
	height: 1.5rem;
	max-width: 1.5rem;
	max-height: 1.5rem;
	min-width: 1.5rem;
	min-height: 1.5rem;
	display: flex;
	align-items: center;
	justify-content: center;
	border: 1px solid ${({ theme }) => theme.color.brand1};
	border-radius: 1rem;
	color: ${({ theme }) => theme.color.brand1};
`;
